import Rete from 'rete';
import {v4 as uuid} from 'uuid';
import {tempActionSocket} from "../sockets";
import {EndComponentHelper} from "../extensions/EndComponentHelper";
import {EndNode} from "../nodes/EndNode";

export class EndComponent extends Rete.Component {

    static get COMPONENT_NAME() { return "End"; };
    static get END_COMPONENT_KEY() { return "EndComponent"; };
    static get END_INPUT_KEY() { return "input"; };

    constructor() {
        super(EndComponent.COMPONENT_NAME);
        this.data.component = EndNode;
    }

    builder(node) {
        if (node.componentId === undefined) {
            node.componentId = uuid();
        }

        let endComponentUUID = node.componentId;

        let input = new Rete.Input(
            EndComponentHelper.getEndNodeInputKey(endComponentUUID),
            "action",
            tempActionSocket,
            true
        );

        return node.addInput(input);
    }

    worker(node, inputs, outputs) {

    }
}